import "./footer.ui.scss";

import { useSelector } from "react-redux";
import { memo }from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { selectShowSpinner, selectShowInnerSpinner } from "../../stores/slice/ui";

import Spinner from "../Spinner";
import LinkerWithA from "components/LinkerWithA";

const Footer = ({
  isHideCookiePreferences
}) => {
  const { t } = useTranslation();
  const thisYear = dayjs().year();
  const showSpinner = useSelector(selectShowSpinner);
  const showInnerSpinner = useSelector(selectShowInnerSpinner);

  return (
    <>
      <div className="footer-container">
        {/* © 20xx D-Link Corporation. All rights reserved. */}
        <span>© { thisYear } {t('d3d2a0249d')}</span>

        {/* Terms */}
        <LinkerWithA href="#/" label={t('b5b7b6c5b5')} />

        {/* Privacy */}
        <LinkerWithA href="#/" label={t('c5f29bb36f')} />

        {/* Cookie Preferences */}
        { !isHideCookiePreferences && <LinkerWithA href="#/" label={t('e3f2b1726d')} /> }
      </div>
      {showSpinner && <Spinner />}
      {showInnerSpinner && <Spinner />}
    </>
  );
};

export default memo(Footer);

